module.exports = __webpack_public_path__ + "img/9b9281705a7dd16e0a15575653751ed5.png";